import styles from './icon-button.module.scss';
import ScreenReaderOnly from 'components/accesibility/screen-reader-only';
import type { HTMLAttributes, MouseEventHandler, ReactNode } from 'react';

const IconButton = ({
	icon,
	label,
	jsxLabel,
	className,
	disabled,
	onClick,
	lightMode,
	small,
	showLabel,
	type,
	...restProps
}: IProps) => {
	const classes = [styles.button];
	small && classes.push(styles.small);
	lightMode && classes.push(styles.lightMode);
	className && classes.push(className);

	return (
		<button
			className={classes.join(' ')}
			disabled={disabled}
			type={type || `button`}
			onClick={onClick}
			{...restProps}
		>
			{icon}
			{showLabel ? (
				(jsxLabel ?? <span>{label}</span>)
			) : (
				<ScreenReaderOnly text={label} />
			)}
		</button>
	);
};

export interface IProps extends HTMLAttributes<HTMLButtonElement> {
	icon: ReactNode;
	label?: string;
	jsxLabel?: ReactNode;
	disabled?: boolean;
	ref?: any;
	onClick?: MouseEventHandler;
	lightMode?: boolean;
	showLabel?: boolean;
	small?: boolean;
	showArrow?: boolean;
	type?: 'submit' | 'button';
}

export default IconButton;
